import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-vmou';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { confirmPopup } from 'primereact/confirmpopup';
import styles from './batchtable.module.css';
import { useHistory } from "react-router-dom";

const Batchtable = (props) => {

    const [batch, setBatch] = useState('');
    const [batches, setBatches] = useState(null);
    const [sendDialog, setSendDialog] = useState(false);
    const [createDialog, setCreateDialog] = useState(false);
    const [batchSize, setBatchSize] = useState(25);
    const [mode,setMode] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('Unassigned');
    const [examinerList, setExamierList] = useState('');
    const [courseList, setCourseList] = useState(null);
    const [cityList, setCityList] = useState(null);
    const [papercityList, setPaperCityList] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory()

    const statuses = [
        "Unassigned",
        "Assigned",
        "All"
    ]
    const exams = [
        "DEC25",
        "JUNE25",
        "DEC24"
    ]
    const regTypes = [
        "Regular",
        "Defaulter",
        "Both"
    ]

    const [selectedExam, setSelectedExam] = useState(exams[0]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedRegType, setSelectedRegType] = useState('Both');

    useEffect(() => {
        let authOptions = {
            method: 'PUT',
            url: '/examiner/prCoord/'+props.userid, 
            data: {'userid':props.userid,'exam':selectedExam},
                headers : {
                'x-auth-token' : localStorage.getItem('token')
            }
        };
        axios(authOptions)
        .then(response => {
            setExamierList(response.data.examiners)
            setCourseList(response.data.prpapers)
            setCityList(response.data.prcities)
            setPaperCityList(response.data.papercity)
        })
        .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
            setExamierList([]);
        });
    },[props.userid,selectedExam]); 




    const hideSendDialog = () => {
        setSendDialog(false);
    }

    const hideCreateDialog = () => {
        setCreateDialog(false);
    }



    const accept = () => {
        let authOptions = {
            method: 'POST',
            url: '/batch/newPractical', 
            data: {'userid':props.userid,'exam':selectedExam,'course':selectedCourse.ccode,'mmarks':selectedCourse.mmarks, 'city':selectedCity.explace, 'regtype':selectedRegType, 'batchsize':batchSize},
            headers : {
                'x-auth-token' : localStorage.getItem('token')
            }
        };
        axios(authOptions)
            .then(response => {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Batches Created', life: 3000 });
            setCreateDialog(false);
        })
            .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
        });
    };

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        hideCreateDialog()
    };

    const confirm1 = (event) => {
        const xx = papercityList.find(e => e.ccode === selectedCourse.ccode && e.explace === selectedCity.explace)
        if (!xx) {
            toast.current.show({ severity: 'error', summary: 'Sorry', detail: 'No student of this course and city is pending.', life: 3000 });
            hideCreateDialog()
            return;
        }
        confirmPopup({
            target: event.currentTarget,
            message: "Total Registered and not in any batch : "+ xx.nos.toString() + ". Are you sure you want to proceed?",
            icon: 'pi pi-exclamation-triangle',
            accept,
            reject
        });
    };


    const saveBatch = () => {
        let _batches = [...batches];
        let _batch = {...batch};
        if (mode === 'Send') {
            if (batch.examinerid) {
                let authOptions = {
                  method: 'PUT',
                  url: '/batch/send', 
                  data: _batch,
                  headers : {
                      'x-auth-token' : localStorage.getItem('token')
                  }
                };
                axios(authOptions)
                    .then(response => {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Batch Edited', life: 3000 });
                    setBatches(_batches);
                    setSendDialog(false);
                })
                  .catch(error => {
                    toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
                });
            } else {
                toast.current.show({severity: 'error', summary: 'Error Message', detail:"Examiner NOT Selected"});
            }
        } else  {
            if (batch.examinerid) {
                let authOptions = {
                  method: 'PUT',
                  url: '/batch/recd', 
                  data: _batch,
                  headers : {
                      'x-auth-token' : localStorage.getItem('token')
                  }
                };
                axios(authOptions)
                    .then(response => {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Batch Edited', life: 3000 });
                    setBatches(_batches);
                    setCreateDialog(false);
                })
                  .catch(error => {
                    toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
                });
            } else {
                toast.current.show({severity: 'error', summary: 'Error Message', detail:"Examiner NOT Selected"});
            }
        }

    }
    const examSearch = (event) => {
        event.preventDefault();  
       let authOptions = {
        method: 'PUT',
        url: '/batch/prCoord/', 
        data: {'userid':props.userid,'exam':selectedExam, 'ccode':selectedCourse.ccode,'city':selectedCity.explace, 'sts': selectedStatus},
        headers : {
            'x-auth-token' : localStorage.getItem('token')
        }
      };
      axios(authOptions)
      .then(response => {
        setBatches(response.data);
      })
      .catch(error => {
        toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
        setBatches([]);
    });
    }
    const awlPrint = (batch) => {
        history.push({
            pathname: '/AwlPrint',
            state: {batch:batch}
        });
    }

    const sendBatch = (batch) => {
        setBatch({...batch});
        setMode('Send');
        setSendDialog(true);
    }
    const createBatch = (batch) => {
        setBatch({...batch});
        setMode('Recd');
        setCreateDialog(true);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _batch = {...batch};
        _batch[`${name}`] = val;
        setBatch(_batch);
    }

    const onExaminerChange = (e) => {
        const val = (e.target && e.target.value) || '';
        let _batch = {...batch};
        _batch.examinerid= val;
        setBatch(_batch);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-arrow-right" tooltip="Assign to Examiner" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => sendBatch(rowData)} />
                <Button icon="pi pi-print" tooltip="Attendance Sheet Printing" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button-warning" onClick={() => awlPrint(rowData)} />
           </React.Fragment>
        );
    }

    const header = (
        <div className={styles.tableheader}>
            <Button label="Export" icon="pi pi-upload" className="p-button-help mr-6" onClick={exportCSV} />
            <Button label="Create" icon="pi pi-copy" className="p-button-success mr-6" onClick={createBatch} />
            {/* <h4 className="mx-0 my-1">Manage Batches</h4> */}
            <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );
    const batchSendDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideSendDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveBatch} />
        </React.Fragment>
    );
    const batchCreateDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideCreateDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={confirm1} />
        </React.Fragment>
    );

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return (dt)?day+"-"+month+"-"+cdt.getFullYear():'' ;
      };
    
    
    const dateBodyTemplate = (rowData) => formatDate(rowData.dtrecd);
    const dateBodyTemplate1 = (rowData) => formatDate(rowData.dtsend);
    const dateBodyTemplate2 = (rowData) => formatDate(rowData.dtsubmitted);

//            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} selection={selectedBatches} onSelectionChange={(e) => setSelectedBatches(e.value)}

    return (
    <div className={styles.datatablecruddemo}>
        <Toast ref={toast} />
        <div className={styles.Sformpr}>
            <div className=" ">
                <label  className="">Select Exam</label>
                <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
            </div>
            <div className=" ">
                <label  className="">Select Course</label>
                <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedCourse} options={courseList} optionLabel="ccode" onChange={(e) => setSelectedCourse(e.value)}  placeholder="Select Course" />
            </div>
            <div className=" ">
                <label  className="">Select City</label>
                <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedCity} options={cityList} optionLabel='explace' onChange={(e) => setSelectedCity(e.value)}  placeholder="Select City" />
            </div>
            <div className=" ">
                <label htmlFor="centre" className="">Select Batch Status</label>
                <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedStatus} options={statuses} onChange={(e) => setSelectedStatus(e.value)}  placeholder="Select Status" />
            </div>
            <Button icon="pi pi-search" tooltip="Search" className="ml-2 p-button-text p-button-success" onClick={examSearch}/>
        </div>
        <div className={styles.card}>
            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} 
                dataKey="ccode" sortField="ccode" sortOrder={1} paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} batches"
                globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                <Column field="ccode" header="Course/Paper" sortable style={{textAlign:'center',   width: '15%', padding:'0 1px 0 1px' }}></Column>
                <Column field="batchcode" header="Batch/Examiner No" sortable style={{textAlign:'center',   width: '15%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="prcity" header="Pr City"  sortable style={{textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="totalcopies" header="Total" style={{textAlign:'center',   width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="examinerid.name" header="Examiner" sortable style={{ textAlign:'left',  width: '20%', padding:'0 1px 0 1px' }}></Column>
                <Column field="dtsend" header="Date Send" body={dateBodyTemplate1} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="dtsubmitted" header="Date Submit" body={dateBodyTemplate2} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="dtrecd" header="Date Recd" body={dateBodyTemplate} sortable style={{textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
            </DataTable>
        </div>

        <Dialog visible={sendDialog} style={{ width: '450px' }} header="Sent to Examiner" modal className="p-fluid" footer={batchSendDialogFooter} onHide={hideSendDialog}>
            <div className="p-field mt-2">
                <label htmlFor="centre" className="">Select Examiner</label>
                <Dropdown filter filterBy='name' placeholder="Select Examiner" className=" w-full" id="examiner"  autoComplete="off" optionLabel="name"  options={examinerList} value={batch.examinerid} onChange={onExaminerChange} />
            </div>
            <div className="p-field mt-2">
                <label htmlFor="role" className="">Date of Practical</label>
                <Calendar monthNavigator yearNavigator yearRange="2010:2030" id="frDate" className="h-2rem" value={batch.dtsend} onChange={(e) => onInputChange(e,"dtsend")} mask="99/99/9999" dateFormat="dd/mm/yy"/>
            </div>
        </Dialog>
        <Dialog visible={createDialog} style={{ width: '450px' }} header="Create New Batches" modal className="p-fluid" footer={batchCreateDialogFooter} onHide={hideCreateDialog}>
            <div className="p-field mt-2">
                <div className="mt-2">
                    <label  className="">Select Exam</label>
                    <Dropdown className=" my-1" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
                </div>
                <div className="mt-2">
                    <label  className="">Select Course</label>
                    <Dropdown className="my-1" value={selectedCourse} options={courseList} optionLabel="ccode" onChange={(e) => setSelectedCourse(e.value)}  placeholder="Select Course" />
                </div>
                <div className="mt-2">
                    <label  className="">Select City</label>
                    <Dropdown className="my-1" value={selectedCity} options={cityList} optionLabel="explace" onChange={(e) => setSelectedCity(e.value)}  placeholder="Select City" />
                </div>
                <div className="mt-2">
                    <label  className="">Select Reg. Type</label>
                    <Dropdown className="my-1" value={selectedRegType} options={regTypes} onChange={(e) => setSelectedRegType(e.value)}  placeholder="Select Reg. Type" />
                </div>
                <div className="mt-2">
                    <label  className="">Batch Size</label>
                    <InputNumber value={batchSize} onValueChange={(e) => setBatchSize(e.value)} required  />
                </div>
            </div>
        </Dialog>
    </div>
    );
}
const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
  }
  
  export default connect(mapStateToProps)(Batchtable);